var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobVacancies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#092C4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8478 14.2472C21.8478 16.5928 19.9463 18.4943 17.6007 18.4943C15.255 18.4943 13.3535 16.5928 13.3535 14.2472C13.3535 11.9015 15.255 10 17.6007 10C19.9463 10 21.8478 11.9015 21.8478 14.2472Z",
    fill: "#092C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9576 21.7056C23.6531 20.914 22.9899 20.3262 21.5815 20.3262H17.6002H13.6194C11.3142 20.3262 11 21.8977 11 23.3642V27.45H20.6512C20.546 27.0603 20.4848 26.6532 20.4848 26.2306C20.4848 24.0661 21.9609 22.2442 23.9578 21.7057L23.9576 21.7056Z",
    fill: "#092C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1779 22.4629C23.0966 22.4629 21.4102 24.15 21.4102 26.2306C21.4102 28.312 23.0966 29.9991 25.1779 29.9991C27.2592 29.9991 28.9456 28.312 28.9456 26.2306C28.9456 24.15 27.2586 22.4629 25.1779 22.4629ZM25.1632 28.1822C25.0845 28.2764 24.9684 28.3313 24.8451 28.3326H24.8413C24.7199 28.3326 24.6038 28.2797 24.5245 28.188L22.798 26.2034L23.4317 25.6525L24.835 27.2655L27.1349 24.5139L27.7794 25.0526L25.1632 28.1822Z",
    fill: "#092C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobVacancies);
export default __webpack_public_path__ + "static/media/JobVacancies.244b6477500e4e67c507f753afd4f7ea.svg";
export { ForwardRef as ReactComponent };